import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, DialogModule } from 'primeng';
import { RouteItineraryComponent } from '../../route-itinerary.component';
import { IRouteRecommendation } from '../../../../../interfaces/route-recommendations/route-recommendation';

@Component({
  selector: 'route-itinerary-popup',
  standalone: true,
  imports: [CommonModule, DialogModule, RouteItineraryComponent, ButtonModule],
  templateUrl: './route-itinerary-popup.component.html',
  styleUrls: ['./route-itinerary-popup.component.css'],
})
export class RouteItineraryPopupComponent implements OnInit, OnChanges {
  constructor() {}

  ngOnInit(): void {
    this.setDialogHeader();
  }

  @Input() showDialog: boolean = false;
  @Output() showDialogChange: EventEmitter<boolean> = new EventEmitter();
  @Input() selectedRoute: IRouteRecommendation;
  @Output() alternateRouteSelected = new EventEmitter<number>();
  @Output() closeDialog = new EventEmitter<void>();
  @Output() routeDetailClick = new EventEmitter<void>();
  @Output() grabOrDeployRouteClick = new EventEmitter<void>();
  @Input() public isVME: boolean = false;

  protected dialogHeader: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedRoute']) {
      this.setDialogHeader();
    }
  }

  setDialogHeader() {
    if (!this.selectedRoute) {
      this.dialogHeader = '';
      return;
    }
    this.dialogHeader = this.selectedRoute.routeNumber + ' - ' + this.getNumberOfTasks();
  }

  getNumberOfTasks() {
    if (this.selectedRoute?.taskCount == 1) {
      return '1 Task';
    }
    return `${this.selectedRoute?.taskCount} Tasks`;
  }

  onAlternateRouteSelected(routeId: number): void {
    this.alternateRouteSelected.emit(routeId);
  }

  onCloseDialog(): void {
    this.closeDialog.emit();
  }
}
